import { navigation } from "./navigation";
import { dashboard } from "./dashboard";
import { players } from "./players.js";
import { gameRounds } from "./gameRounds.js";
import { otpList } from "./otpList";
import { liveTransaction } from "./liveTransaction";
import { depositTransaction } from "./depositTransaction";
import { withdrawTransaction } from "./withdrawTransaction";
import { approveTopup } from "./approveTopup";
import { approvePayout } from "./approvePayout";
import { newMember } from "./newMember";
import { affiliateSummary } from "./affiliateSummary";
import { nonAffiliateSummary } from "./nonAffiliateSummary";
import { affiliatePayout } from "./affiliatePayout";
import { commissionSummary } from "./commissionSummary";
import { commissionPayout } from "./commissionPayout";
import { loyaltyConfig } from "./loyaltyConfig";
import { rewardCategory } from "./rewarcCategory";
import { reward } from "./reward";
import { loyaltyInfo } from "./loyaltyInfo";
import { rewardRedemption } from "./rewardRedemption";
import { pointRequest } from "./pointRequest";
import { pointRequestHistory } from "./pointRequestHistory";
import { banner } from "./banner";
import { userActivityLog } from "./userActivityLog";
import { adminActivityLog } from "./adminActivityLog";
import { usernameUpdateRequest } from "./usernameUpdateRequest";
import { usernameUpdateHistory } from "./usernameUpdateHistory";
import { dailyReport } from "./dailyReport";
import { gameReport } from "./gameReport";
import { playerReport } from "./playerReport";
import { summaryReport } from "./summaryReport";
import { gameRankingReport } from "./gameRankingReport";
import { player } from "./player";
import { event } from "./event";
import { blacklist } from "./blacklist";
import { logIn } from "./logIn";
import {ticketManagement} from './ticketManagement'
import { paymentConfig } from "./paymentConfig";
import { paymentDailyReport } from "./PaymentDailyReport";
import { withdrawPaymentSwitching } from "./withdrawPaymentSwitching"
import { depositPaymentSwitching } from "./depositPaymentSwitching.js"
import { stream } from "./stream";
import {playerTier} from './playerTier'
import { activityLog } from "./activityLog";
import {approvePayoutV2} from "./approvePayoutV2";
import {approveTopupV2} from "./approveTopupV2";
import { bankVerifyConfig } from "./bankVerifyConfig";
import { tierConfig } from "./tierConfig";
import {paymentDepositTieringConfig} from "@/i18n/th/payment-deposit-tiering-config";
import {multipleDepositConfig} from "./multipleDepositConfig"
import {manualDepositWithdraw} from "@/i18n/th/manualDepositWithdraw";
import {coupon} from "@/i18n/th/coupon";

export const thai = {
  messages: {
    navigation: { ...navigation },
    dashboard: { ...dashboard },
    players: { ...players },
    player: { ...player },
    gameRounds: { ...gameRounds },
    otpList: { ...otpList },
    liveTransaction: { ...liveTransaction },
    depositTransaction: { ...depositTransaction },
    withdrawTransaction: { ...withdrawTransaction },
    approveTopup: { ...approveTopup },
    approvePayout: { ...approvePayout },
    newMember: { ...newMember },
    affiliateSummary: { ...affiliateSummary },
    nonAffiliateSummary: { ...nonAffiliateSummary },
    affiliatePayout: { ...affiliatePayout },
    commissionSummary: { ...commissionSummary },
    commissionPayout: { ...commissionPayout },
    loyaltyConfig: { ...loyaltyConfig },
    rewardCategory: { ...rewardCategory },
    reward: { ...reward },
    loyaltyInfo: { ...loyaltyInfo },
    rewardRedemption: { ...rewardRedemption },
    pointRequest: { ...pointRequest },
    pointRequestHistory: { ...pointRequestHistory },
    banner: { ...banner },
    userActivityLog: { ...userActivityLog },
    adminActivityLog: { ...adminActivityLog },
    usernameUpdateRequest: { ...usernameUpdateRequest },
    usernameUpdateHistory: { ...usernameUpdateHistory },
    dailyReport: { ...dailyReport },
    gameReport: { ...gameReport },
    playerReport: { ...playerReport },
    summaryReport: { ...summaryReport },
    gameRankingReport: { ...gameRankingReport },
    playerTier:{...playerTier},
    event: { ...event },
    blacklist: { ...blacklist },
    logIn: { ...logIn },
    ticketManagement:{...ticketManagement},
    paymentConfig: { ...paymentConfig },
    paymentDailyReport: {...paymentDailyReport},
    withdrawPaymentSwitching: {...withdrawPaymentSwitching},
    depositPaymentSwitching: {...depositPaymentSwitching},
    activityLog: { ...activityLog },
    approvePayoutV2: { ...approvePayoutV2 },
    approveTopupV2: { ...approveTopupV2 },
    stream:{...stream},
    bankVerifyConfig:{...bankVerifyConfig},
    tierConfig:{...tierConfig},
    paymentDepositTieringConfig: {...paymentDepositTieringConfig},
    multipleDepositConfig:{...multipleDepositConfig},
    manualDepositWithdraw: {...manualDepositWithdraw},
    coupon: {...coupon},
  },
};
